import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../contexts/ToastContext";
import Loader from "../../components/elements/Loader";

const StripeAccountFailed = () => {
  const { showErrorToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    showErrorToast(
      'Session expired. Please click "Connect with Stripe" to restart the onboarding process.'
    );
    navigate("/profile");
  }, []);

  return <Loader />;
};

export default StripeAccountFailed;
